module.exports = __webpack_public_path__ + "img/064-lithuania.a14940a6.svg";